<div class="p-container">
  <div class="w-full p-6 mx-auto sm:px-8">


      <!-- Graph Module -->

      <div class="grid md:grid-cols-12 ">

        <div class="col-span-7">
          <patient-hydration-history-graph>
            
          </patient-hydration-history-graph>

        </div>

      </div>

      <!-- History List Module -->
      <ng-container *ngIf="!loading">
          <patient-hydration-history-list
              [trackId] ="trackId"
              [history]="historyData"
              (hydrationUpdated)="onHydrationUpdated()"
              >
          </patient-hydration-history-list>
      </ng-container>

      <div *ngIf="loading" class="flex justify-center p-12">
          <i class="pi pi-spin pi-spinner text-3xl text-gray-300"></i>
      </div>
  </div>
</div>
